<template>
  <div class="w-screen min-h-screen overflow-y-auto overflow-x-hidden bg-white relative pb-20">
    <div class="w-full min-h-screen overflow-y-auto overflow-x-hidden bg-white relative">

      <!-- Header -->
      <div class="w-full bg-white px-4 py-3 border-b border-gray-200 flex justify-between items-center print:hidden">
        <div class="flex items-center gap-2">
          <button @click="$router.push({ name: 'JobSheet' })" class="text-blue-600 hover:text-blue-800">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
          </button>
          <div class="font-bold text-blue-600">KEMBALI</div>
        </div>
      </div>

      <!-- Content -->
      <div class="p-4 max-w-3xl mx-auto">
        <!-- Title -->
        <div class="text-center mb-6">
          <h5 class="font-bold text-blue-600">TAMBAH JOB SHEET INDIVIDUAL</h5>
          <h6 class="font-bold text-red-500">EF-PRINT</h6>
        </div>

        <div class="mb-8 p-6 border rounded-xl bg-gray-50 shadow-sm">
          <form @submit.prevent="submitForm">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
              <!-- Tanggal Masuk -->
              <div>
                <label class="block font-semibold mb-1 text-xs text-gray-700">Tanggal Masuk :</label>
                <input v-model="form.tanggal" type="date" required
                  class="w-full border border-gray-300 py-2 px-3 rounded-md text-sm bg-white focus:outline-none focus:border-blue-500 shadow-sm">
              </div>

              <!-- Target Selesai -->
              <div>
                <label class="block font-semibold mb-1 text-xs text-gray-700">Target Selesai :</label>
                <input v-model="form.target_finish" type="date" required
                  class="w-full border border-gray-300 py-2 px-3 rounded-md text-sm bg-white focus:outline-none focus:border-blue-500 shadow-sm">
              </div>

              <!-- Nama / PIC -->
              <div>
                <label class="block font-semibold mb-1 text-xs text-gray-700">Nama Personil :</label>
                <select v-model="form.pic_koordinator_id" required
                  class="w-full border border-gray-300 py-2 px-3 rounded-md text-sm bg-white focus:outline-none focus:border-blue-500 shadow-sm">
                  <option value="" disabled>-- Pilih Karyawan --</option>
                  <option v-for="u in users" :key="u.id_user" :value="u.id_user">{{ u.nama_lengkap }}</option>
                </select>
              </div>

              <!-- Pelanggan -->
              <div class="relative">
                <label class="block font-semibold mb-1 text-xs text-gray-700">Nama Pelanggan :</label>
                <input v-model="searchPelanggan" @focus="showPelangganDropdown = true" @blur="hidePelangganDropdown" type="text" placeholder="Cari Pelanggan..." class="w-full border border-gray-300 py-2 px-3 rounded-md text-sm bg-white focus:outline-none focus:border-blue-500 shadow-sm" />
                <ul v-show="showPelangganDropdown" class="absolute z-10 w-full bg-white border border-gray-300 rounded-md mt-1 max-h-40 overflow-y-auto shadow-lg">
                  <li v-if="filteredPelanggans.length === 0" class="px-3 py-2 text-sm text-gray-500">Tidak ditemukan</li>
                  <li v-for="p in filteredPelanggans" :key="p.id_pelanggan" @mousedown.prevent="selectPelanggan(p)" class="px-3 py-2 text-sm cursor-pointer hover:bg-blue-100">{{ p.nama }}</li>
                </ul>
              </div>

              <!-- Pekerjaan / Catatan -->
              <div class="md:col-span-2">
                <label class="block font-semibold mb-1 text-xs text-gray-700">Deskripsi Pekerjaan :</label>
                <textarea v-model="form.catatan" rows="4" required
                  class="w-full border border-gray-300 py-2 px-3 rounded-md text-sm bg-white focus:outline-none focus:border-blue-500 shadow-sm"
                  placeholder="Tuliskan deskripsi pekerjaan..."></textarea>
              </div>
            </div>

            <div class="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-200">
              <button type="button" @click="$router.push({ name: 'JobSheet' })"
                class="bg-gray-500 hover:bg-gray-600 text-white py-2 px-6 rounded-md font-semibold text-sm transition-colors">
                Batal
              </button>
              <button type="submit" :disabled="isLoading"
                class="bg-green-600 hover:bg-green-700 text-white py-2 px-6 rounded-md font-semibold text-sm transition-colors flex items-center justify-center min-w-[120px] shadow-sm">
                <span v-if="isLoading" class="mr-2">Menyimpan...</span>
                <span v-else>Simpan Data</span>
              </button>
            </div>
          </form>
        </div>
      </div>

      <bottom-nav></bottom-nav>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import BottomNav from '../components/BottomNav.vue'

export default {
  name: 'CreateJobSheetIndividual',
  components: { BottomNav },
  data() {
    return {
      isLoading: false,
      users: [],
      pelanggans: [],
      searchPelanggan: '',
      showPelangganDropdown: false,
      form: {
        type: 'individual',
        tanggal: new Date().toISOString().split('T')[0],
        target_finish: '',
        pic_koordinator_id: '',
        pelanggan_id: '',
        catatan: ''
      }
    }
  },
  computed: {
    filteredPelanggans() {
      if (!this.searchPelanggan) return this.pelanggans
      const lower = this.searchPelanggan.toLowerCase()
      return this.pelanggans.filter(p => p.nama && p.nama.toLowerCase().includes(lower))
    }
  },
  mounted() {
    this.fetchUsers()
    this.fetchPelanggans()
  },
  methods: {
    async fetchUsers() {
      try {
        const response = await axios.get('/e_transaksi/job_sheet/get_users', {
          params: { token: this.$store.state.token }
        })
        if (response.data.status) {
          this.users = response.data.data
        }
      } catch (error) {
        console.error('Failed to fetch users:', error)
      }
    },
    async fetchPelanggans () {
      try {
        const response = await axios.get('/e_transaksi/job_sheet/get_pelanggans', {
          params: { token: this.$store.state.token }
        })
        if (response.data.status) {
          this.pelanggans = response.data.data
        }
      } catch (error) {
        console.error('Failed to fetch pelanggans:', error)
      }
    },
    selectPelanggan (p) {
      this.form.pelanggan_id = p.id_pelanggan
      this.searchPelanggan = p.nama
      this.showPelangganDropdown = false
    },
    hidePelangganDropdown () {
      setTimeout(() => {
        this.showPelangganDropdown = false
      }, 200)
    },
    async submitForm() {
      if (!this.form.tanggal || !this.form.target_finish || !this.form.pic_koordinator_id || !this.form.catatan) {
        alert('Mohon lengkapi semua field yang wajib diisi!')
        return
      }

      this.isLoading = true

      try {
        const formData = new URLSearchParams()
        formData.append('token', this.$store.state.token)
        Object.keys(this.form).forEach(key => {
          formData.append(key, this.form[key])
        })

        const response = await axios.post('/e_transaksi/job_sheet/store', formData)

        if (response.data.status) {
          alert(response.data.message || 'Job Sheet Individual berhasil disimpan!')
          this.$router.push({ name: 'JobSheet' })
        } else {
          alert(response.data.message || 'Terjadi kesalahan saat menyimpan data.')
        }
      } catch (error) {
        console.error(error)
        alert('Terjadi kesalahan koneksi server.')
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
